import { connect }               from 'react-redux';
import { doCheckAuthentication } from 'src/actions/aunthenticateAction';
import { onFilesError }          from 'src/actions/supportPageAction';
import FeedbackPage              from './FeedbackPage';
import { Dispatch }              from 'redux';
import { AppState }              from '../../redux';
// import { push } from 'react-router-redux';
import {
  saveRating,
  doFeedback,
  saveComments,
  resetFields,
  checkedValuesGeneral,
  checkedValuesAnterior,
  checkedValuesCopings,
  checkedValuesModel,
  checkedValuesAbutment,
  checkedValuesCutback,
  saveFbType,
  fbpmresetFields,
  handleCheckboxChange,
  onFilesChange,
  deleteRowbyId,
} from '../../actions/feedbackAction';

export const mapStateToProps = (state: AppState) => {
  return {
    totalRating: state.feedback.rating,
    comments: state.feedback.comments,
    fbtype: state.feedback.fbtype,
    feedbackparameters: state.completeOrder.feedbackparameters,
    submitFbFiles: state.feedback.submitFbFiles,
    feedbacktypes: state.completeOrder.feedbacktypes,
    orderno: state.completeOrder.viewCompleteOrder[0].orderno,
    orderdate: state.completeOrder.viewCompleteOrder[0].orderdate,
    completedon: state.completeOrder.viewCompleteOrder[0].completedon,
    tat: state.completeOrder.viewCompleteOrder[0].tat,
    fname: state.completeOrder.viewCompleteOrder[0].fname,
    tool_preferred: state.completeOrder.viewCompleteOrder[0].tool_preferred,
    destination: state.completeOrder.viewCompleteOrder[0].destination,
    modelonly: state.completeOrder.viewCompleteOrder[0].modelonly,
    approval_reqd: state.completeOrder.viewCompleteOrder[0].approval_reqd,
    bravopremium: state.completeOrder.viewCompleteOrder[0].bravopremium,
    nounits: state.completeOrder.viewCompleteOrder[0].nounits,
  };
};

export const mapDispatchToProps = (dispatch: Dispatch<AppState>) => {
  return {
    onSubmit: () => {
      dispatch(doFeedback);
    },
    onReset: () => {
      dispatch(resetFields);
    },
    onResetFbParams: () => {
      dispatch(fbpmresetFields);
    },
    saveRating: (rating: number) => {
      dispatch(saveRating(rating));
    },
    saveComments: (comments: string) => {
      dispatch(saveComments(comments));
    },
    saveFbType: (fbtype: string) => {
      dispatch(saveFbType(fbtype));
    },
    handleCheckboxChange: (value: string, list: string, checked: boolean) => {
      dispatch(handleCheckboxChange(value, list, checked));
    },
    onFilesChange: function (submitFbFiles: Array<File>) {
      dispatch(onFilesChange(submitFbFiles));
    },
    onFilesError: function (error: Error, images: Array<File>) {
      dispatch(onFilesError(error, images));
    },
    deleteRowbyId: (event: React.ChangeEvent<{ value: string }>) => {
      dispatch(deleteRowbyId(event));
    },
    checkedValuesGeneral: (event: React.ChangeEvent<HTMLInputElement>) => {
      dispatch(checkedValuesGeneral(event));
    },
    checkedValuesAnterior: (event: React.ChangeEvent<HTMLInputElement>) => {
      dispatch(checkedValuesAnterior(event));
    },
    checkedValuesCopings: (event: React.ChangeEvent<HTMLInputElement>) => {
      dispatch(checkedValuesCopings(event));
    },
    checkedValuesModel: (event: React.ChangeEvent<HTMLInputElement>) => {
      dispatch(checkedValuesModel(event));
    },
    checkedValuesAbutment: (event: React.ChangeEvent<HTMLInputElement>) => {
      dispatch(checkedValuesAbutment(event));
    },
    checkedValuesCutback: (event: React.ChangeEvent<HTMLInputElement>) => {
      dispatch(checkedValuesCutback(event));
    },
    onComponentDidMount: () => {
      // dispatch(resetFields);
    },
    onComponentWillMount: () => {
      dispatch(doCheckAuthentication);
      dispatch(resetFields);
    },
  };
};

const FeedbackPageContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(FeedbackPage);

export default FeedbackPageContainer;



// WEBPACK FOOTER //
// ./src/components/feedback/FeedbackPageContainer.tsx